var map = {
	"./aimlanalytics.json": 2692,
	"./arvrxr.json": 3794,
	"./innovationentre.json": 161,
	"./iotrf.json": 3293,
	"./noncircuit.json": 5259,
	"./uiuxcreative.json": 4022,
	"./webmobile.json": 1645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 315;